// @flow

import React from 'react';
import {Link} from 'react-router-dom';
import {Button, IconButton, makeStyles} from '@material-ui/core';

import {colors} from '../../../../../assets/styles/colors';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import type {Node} from 'react';
import type {Theme} from '@material-ui/core';

type Props = {
  title: Node,
  to: string,
  hiddeButton?: boolean,
  disabled?: boolean,
};

const useStyles = makeStyles((theme: Theme) => ({
  row: {
    borderTop: `1px solid ${colors.grey200}`,
    textDecoration: 'none',
    width: '100%',

    '&[data-disabled="true"]': {
      color: colors.grey500,
      pointerEvents: 'none',
    },
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 0),
  },
  anchor: {
    textTransform: 'none',
    // '&:hover': {
    //   backgroundColor: colors.grey200,
    // },
  },
}));

export default function LinkButton({
  title,
  to,
  hiddeButton = false,
  disabled,
}: Props) {
  const classes = useStyles();

  const component = (
    <div className={classes.row} data-disabled={disabled ? 'true' : 'false'}>
      <div className={classes.content}>
        {title}
        {!hiddeButton && (
          // <Link to={to}>
          <IconButton>
            <ChevronRightIcon />
          </IconButton>
          // </Link>
        )}
      </div>
    </div>
  );

  return hiddeButton ? (
    component
  ) : (
    <Button
      fullWidth
      to={to}
      component={Link}
      className={classes.anchor}
      disabled={disabled}
    >
      {component}
    </Button>
  );
}
